export default __webpack_public_path__ + "static/media/logoequt.281d30f8.png";